
      export default {
        functional: true,
        render: 
      function render(_h, _vm) {
        var _c=_vm._c;return _c('svg',{class:[_vm.data.class, _vm.data.staticClass],style:([_vm.data.style, _vm.data.staticStyle]),attrs:{"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 47 49"}},[_c('path',{attrs:{"fill":"#062521","d":"M27.705 49C40.001 49 47 38.022 47 22.988 47 7.953 35.053 0 22.758 0S0 13.398 0 28.432 15.41 49 27.705 49z"}})])
      }
    
      }
    